
(function () {
  function initTrustStripMobile() {
    var strip = document.querySelector('.seg-trust-strip');
    if (!strip) return;

    var track = strip.querySelector('.seg-trust-strip__inner');
    var items = Array.prototype.slice.call(strip.querySelectorAll('.seg-trust-strip__item'));
    if (!track || items.length < 2) return;

    if (strip.dataset.mobileTrustReady === 'true') return;
    strip.dataset.mobileTrustReady = 'true';

    var index = 0;

    function isMobile() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function render() {
      if (isMobile()) {
        /* Track is 400% wide and each item is 25%, so move by 25% per slide */
        track.style.transform = 'translate3d(-' + (index * 25) + '%, 0, 0)';
      } else {
        index = 0;
        track.style.transform = '';
      }
    }

    window.setInterval(function () {
      if (!isMobile()) return;
      index = (index + 1) % items.length;
      render();
    }, 3500);

    window.addEventListener('resize', render);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrustStripMobile);
  } else {
    initTrustStripMobile();
  }

  window.addEventListener('load', initTrustStripMobile);
  document.addEventListener('shopify:section:load', initTrustStripMobile);
})();
